/**
 * Les modals ecowatt
 */
export const ModalTypesEcoWattFeatureFlipping = {
  ROUGE_ORANGE_FEATURE_FLIPPING_OFF: 'modal-ecowatt-rouge-orange-feature-flipping-off',
  ROUGE_ORANGE_FEATURE_FLIPPING_ON: 'modal-ecowatt-rouge-orange-feature-flipping-on',
};
